<template>
  <div></div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    goToAbout() {
      this.$router.push('/taskList');
    }
  }
}
</script>

<style scoped>

</style>